import React, { useState, useEffect } from "react";
import Modal from "../../../../components/modal";
import {  CompanyIdInput } from "../../../../utils/formDataId";

const TaxesForm = ({ show, onClose, heading, initialData = {}, onSubmit }) => {
    
   
    const [formData, setFormData] = useState({
        
        name: '',
        hsn_code: '',
        rate: ''
    });
    
   

    // Load initial data into form if editing an existing tax
    useEffect(() => {
        if (initialData) {
            setFormData({
                name: initialData.name || '',
                hsn_code: initialData.hsn_code || '',
                rate: initialData.rate || ''
            });
        }
    }, [initialData]);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <Modal
            show={show}
            onClose={onClose}
            heading={heading}
        >
            <form onSubmit={handleSubmit}>
                
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group mb-4">
                            <label>Name</label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter Tax Name"
                                required
                            />
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="form-group mb-4">
                            <label>Rate (%)</label>
                            <input
                                type="number"
                                name="rate"
                                className="form-control"
                                value={formData.rate}
                                onChange={handleChange}
                                placeholder="Enter Tax Rate"
                                required
                                min="0"
                                step="0.01"
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group mb-4">
                            <label>HSN/SAC Code</label>
                            <input
                                type="text"
                                name="hsn_code"
                                className="form-control"
                                value={formData.hsn_code}
                                onChange={handleChange}
                                placeholder="Enter HSN Code"
                            />
                        </div>
                    </div>

                </div>

                <div className="d-flex justify-content-end">
                    <button 
                        type="button" 
                        className="btn btn-light me-2" 
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                        Save
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default TaxesForm;
